import * as React from "react";
import { OwnerUser } from "../../core";
import defaultImage from "../../assets/images/user-noimage.png";
import { UserAvatar } from "../render-file/UserAvatar";

interface ICrmAgentColumnProps {
  user?: OwnerUser;
}

const CrmAgentColumn: React.FunctionComponent<ICrmAgentColumnProps> = (
  props
) => {
  if (!props.user) {
    return <></>;
  }
  return (
    <div className="user d-inline-flex align-items-center">
      <div className="user-img">
        <div className="avatar-progress avatar-progress--xs position-relative cursor-pointer">
          <svg>
            <circle r="12" cx="50%" cy="50%" className="default"></circle>
            <circle
              r="12"
              cx="50%"
              cy="50%"
              className="progress"
              stroke-dasharray="117"
              stroke-dashoffset="75"
            ></circle>
          </svg>
          <UserAvatar
            id={props.user?._id}
            className="position-absolute left-0 right-0 top-0 bottom-0 m-auto rounded-circle"
            alt={props.user?.name}
            title={props.user?.name}
            imageUrl={props.user?.avatar?.location}
            image={props.user?.avatar}
          ></UserAvatar>
        </div>
      </div>
      <div className="user-name text-truncate ml-2">{props.user.name}</div>
    </div>
  );
};

export default CrmAgentColumn;
